/* RUB HUB MEGA MENU — 2026-10-25. Hover-intent open/close, tap-to-open on touch, keyboard (Esc/Tab),
   dims the page while a panel is open, and click tracking (Shopify.analytics.publish 'rh_menu_click' +
   dataLayer). Event delegation on document, so it also works on any cloned sticky header copy. */
(function(){
  if (window.__rhMega) return; window.__rhMega = true;
  var OPEN_DELAY = 140, CLOSE_DELAY = 220, openTimer = null, closeTimer = null, current = null;
  var mqDesktop = window.matchMedia('(min-width: 1025px)');
  var coarse = window.matchMedia('(hover: none), (pointer: coarse)');

  function setOpen(item, open){
    if (!item) return;
    item.classList.toggle('is-open', open);
    var a = item.querySelector(':scope > .rhm-top');
    if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAll(except){
    document.querySelectorAll('.rhm-item.is-open').forEach(function(i){ if (i !== except) setOpen(i, false); });
    if (!except) { current = null; document.body.classList.remove('rhm-open'); }
  }
  function open(item){
    clearTimeout(closeTimer);
    closeAll(item); setOpen(item, true); current = item; document.body.classList.add('rhm-open');
    document.dispatchEvent(new CustomEvent('rhm:open'));
  }
  function itemFrom(el){ return el && el.closest ? el.closest('[data-rhm-item]') : null; }

  document.addEventListener('mouseover', function(e){
    if (!mqDesktop.matches || coarse.matches) return;
    var item = itemFrom(e.target);
    if (item) {
      clearTimeout(closeTimer); clearTimeout(openTimer);
      if (current === item) return;
      openTimer = setTimeout(function(){ open(item); }, current ? 40 : OPEN_DELAY);
    } else if (e.target.closest && e.target.closest('.rhm-root')) {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function(){ closeAll(); }, CLOSE_DELAY);
    }
  });
  document.addEventListener('mouseout', function(e){
    if (!mqDesktop.matches || coarse.matches) return;
    var item = itemFrom(e.target); if (!item) return;
    if (e.relatedTarget && item.contains(e.relatedTarget)) return;
    clearTimeout(openTimer);
    closeTimer = setTimeout(function(){ closeAll(); }, CLOSE_DELAY);
  });

  // touch / tablet: first tap on a parent opens its panel, second tap follows the link
  document.addEventListener('click', function(e){
    var top = e.target.closest && e.target.closest('.rhm-has-panel > .rhm-top');
    if (top && mqDesktop.matches && coarse.matches) {
      var item = itemFrom(top);
      if (!item.classList.contains('is-open')) { e.preventDefault(); open(item); return; }
    }
    if (current && !(e.target.closest && e.target.closest('.rhm-root'))) closeAll();
  }, true);

  // keyboard
  document.addEventListener('focusin', function(e){
    if (!mqDesktop.matches) return;
    var item = itemFrom(e.target);
    if (item) { if (current !== item) open(item); }
    else if (current) closeAll();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && current) {
      var a = current.querySelector(':scope > .rhm-top'); closeAll(); if (a) a.focus();
    }
  });
  // close once the shopper has genuinely scrolled away (not on the tiny scroll nudges sticky headers make)
  var openY = 0;
  document.addEventListener('rhm:open', function(){ openY = window.scrollY; });
  window.addEventListener('scroll', function(){ if (current && Math.abs(window.scrollY - openY) > 220) closeAll(); }, {passive:true});

  // tracking
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-rhm-track]'); if (!a) return;
    var parts = (a.getAttribute('data-rhm-track') || '').split('|');
    var payload = { surface: parts[0], panel: parts[1] || '', label: parts.slice(2).join(' / ') || parts[1] || '', url: a.getAttribute('href') || '' };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('rh_menu_click', payload); } catch(err){}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'rh_menu_click', rh_menu: payload }); } catch(err){}
  });
})();
